module.exports = __webpack_public_path__ + "static/media/carat.9f4d9eb3.svg";